import { Avatar } from './Avatar.js';
import styles from './MemberChip.module.css';
import { cx, memberStyle } from './color.js';

export interface MemberChipProps {
  name: string;
  colorKey: string;
  icon?: string | null;
  /** Naam tonen (standaard). Zonder naam blijft alleen het avatartje over (met aria-label). */
  showName?: boolean;
  /** sm = web-lijsten (28 px), md = web-kaarten (36 px), kiosk = kioskrijen (44 px). */
  size?: 'sm' | 'md' | 'kiosk';
  /** Rode "wie rijdt?"-variant e.d.: toont de chip als open vraag in de waarschuwingskleur. */
  /** muted = voorbije afspraak: neutraal vlak, gedempte (maar leesbare) tekst. */
  tone?: 'member' | 'warning' | 'muted';
  /** Zonder avatar ("Iedereen" in de ouderapp: geen initiaal I voor het hele gezin). */
  plain?: boolean;
}

/**
 * Pil met avatar en naam in de lidtint (ONTWERP.md §7.1 avatarchips). Gebruikt op events,
 * brengen/halen ("Papa rijdt") en in de webkalender.
 */
export function MemberChip({
  name,
  colorKey,
  icon,
  showName = true,
  size = 'md',
  tone = 'member',
  plain = false,
}: MemberChipProps) {
  return (
    <span
      class={cx(
        styles.chip,
        styles[size],
        !showName && styles.iconOnly,
        plain && styles.plain,
        tone === 'warning' && styles.warning,
        tone === 'muted' && styles.muted,
      )}
      style={memberStyle(colorKey)}
      aria-label={showName ? undefined : name}
      role={showName ? undefined : 'img'}
    >
      {plain ? null : (
        <Avatar
          name={name}
          colorKey={colorKey}
          icon={icon ?? null}
          size="chip"
          px={size === 'sm' ? 24 : size === 'kiosk' ? 40 : 32}
          decorative
        />
      )}
      {showName ? <span class={styles.name}>{name}</span> : null}
    </span>
  );
}
